require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-employment-opportunities.json") })
        }
      }, "path---careers-employment-opportunities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-employment-opportunities!./.cache/json/careers-employment-opportunities.json
// module id = 1225
// module chunks = 231608221292675